/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgNoteCreate
 */
export interface OrgNoteCreate {
    /**
     * 
     * @type {string}
     * @memberof OrgNoteCreate
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteCreate
     */
    note: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteCreate
     */
    note_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteCreate
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrgNoteCreate interface.
 */
export function instanceOfOrgNoteCreate(value: object): value is OrgNoteCreate {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('note_name' in value) || value['note_name'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrgNoteCreateFromJSON(json: any): OrgNoteCreate {
    return OrgNoteCreateFromJSONTyped(json, false);
}

export function OrgNoteCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgNoteCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'note': json['note'],
        'note_name': json['note_name'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrgNoteCreateToJSON(json: any): OrgNoteCreate {
    return OrgNoteCreateToJSONTyped(json, false);
}

export function OrgNoteCreateToJSONTyped(value?: OrgNoteCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'note': value['note'],
        'note_name': value['note_name'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

